import { ModuloValutazioneRisposta } from ".";

export class ModuloValutazioneCompetenza {
    id!: string;
    testo!: string;
    risposte!: Array<ModuloValutazioneRisposta>;
    risposta?: ModuloValutazioneRisposta;
}